
export default function InheritedPropertyFAQ() {
  const faqs = [
    {
      question: "Can I sell an inherited apartment building before probate is complete?",
      answer: "In most states, you cannot legally transfer title until probate court approves the sale. However, you can accept offers and prepare for closing during probate. We work with your attorney to expedite court approval and close quickly once authorized."
    },
    {
      question: "What if the property has an existing mortgage?",
      answer: "Existing mortgages are paid off at closing from the sale proceeds. We coordinate with the lender to obtain payoff amounts and ensure smooth closing. If the mortgage exceeds the property value, we can discuss options with you and your attorney."
    },
    {
      question: "Do all heirs need to agree to sell?",
      answer: "Generally yes, unless the will or trust gives one person sole authority. We’ve helped many families reach consensus by providing fair market analysis and explaining the costs of delay. Our transparent process helps all heirs feel confident in the decision."
    },
    {
      question: "What happens to the tenants when I sell?",
      answer: "Tenants and their leases transfer to the new owner at closing. We buy properties with tenants in place—you don't need to terminate leases or deal with tenant issues. We handle all tenant communication after closing."
    },
    {
      question: "How do you determine your offer price?",
      answer: "We analyze comparable sales, current rents, property condition, and market trends. Our offers reflect true market value for AS IS condition. We show you our analysis and explain our valuation—complete transparency, no hidden calculations."
    },
    {
      question: "What if the property needs major repairs?",
      answer: "We buy properties AS IS, regardless of condition. Roof leaks, foundation issues, outdated systems—we handle everything. You don't spend a dollar on repairs. We factor repair costs into our offer and take care of everything after closing."
    },
    {
      question: "How long does the process take?",
      answer: "Timeline depends on probate status. If probate is complete, we can close in 14-21 days. If probate is ongoing, we provide an offer immediately and close 2-4 weeks after court approval. We work on your timeline."
    },
    {
      question: "What are the tax implications of selling inherited property?",
      answer: "You receive a \"step-up in basis\" to fair market value at date of death, often eliminating capital gains tax. However, tax situations vary. We recommend consulting a CPA and can connect you with professionals who specialize in inherited property."
    },
    {
      question: "Can you buy property in multiple states?",
      answer: "Yes, we purchase apartment buildings nationwide. We're experienced with different state probate laws and can handle remote transactions. Distance is not an issue—we've closed deals where heirs never visited the property."
    },
    {
      question: "What if there are liens or title issues?",
      answer: "We work with title companies to resolve liens, judgments, and title defects. Many issues can be cleared at closing from sale proceeds. We've successfully closed transactions with complex title situations that other buyers walked away from."
    },
    {
      question: "Do you charge any fees?",
      answer: "No. We don't charge fees, commissions, or closing costs. Our offer is what you receive (minus standard closing costs like title insurance and transfer taxes, which we can discuss covering in some situations)."
    },
    {
      question: "What if I'm not sure I want to sell yet?",
      answer: "No problem. We can provide a no-obligation evaluation and offer. Many families use our offer as a baseline while exploring other options. There's no pressure—we're here when you're ready."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We've answered thousands of questions from families selling inherited properties. Here are the most common concerns.
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300">
              <h3 className="text-xl font-bold mb-4 text-gray-900 flex items-start gap-3">
                <i className="ri-question-line text-teal-500 text-2xl flex-shrink-0"></i>
                {faq.question}
              </h3>
              <p className="text-gray-700 leading-relaxed pl-11">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl p-10 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Still Have Questions?</h3>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            Every inherited property situation is unique. We're happy to discuss your specific circumstances and provide personalized guidance—no obligation.
          </p>
          <a
            href="#contact"
            className="inline-block whitespace-nowrap bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Schedule a Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
